module.exports = __webpack_public_path__ + "img/logo-sportplatzmedia.c3e7168c.svg";